import { render, staticRenderFns } from "./AclModulos.vue?vue&type=template&id=a3a5f384"
import script from "./AclModulos.vue?vue&type=script&lang=js"
export * from "./AclModulos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports